import { useContext, useEffect, useState } from "react";
import { Stack } from "@mui/material";
import { Button } from '@chr/eds-react';
import { ConfigContext } from "@chr/navisphereonline-shared-components";
import { useTranslation } from "@chr/online-shared-ui-localizations";
import { PermissionsByPartyCode } from "@/common/constants/permission-types";
import { launchdarkly } from "@/common/apis/launchdarkly";
import { useAnalytics } from "@/common/hooks/useAnalytics";
import { VisibilityBooking } from "@/common/apis/dtos";
import { featureFlagNames } from "@/common/constants/featureFlags";
import { OrderCondition as BookingConditions } from '@chr/online-shared-ui-constants';

export interface ActionButtonGroupProps {
  booking: VisibilityBooking;
  permissions?: PermissionsByPartyCode;
  handleCancellation?: () => void;
}

export const ActionButtonGroup = ({ booking, permissions }: ActionButtonGroupProps) => {
  const translate = useTranslation();
  const config = useContext(ConfigContext) as AppConfig;
  const analytics = useAnalytics();

  const [editAllowed, setEditAllowed] = useState(false);

  useEffect(() => {
    const setFeaturesAllowedFromFlags = async () => {
      const flags = await launchdarkly();
      setEditAllowed(flags[featureFlagNames.userHasAccessToEditBooking]);
    };
    setFeaturesAllowedFromFlags();
  }, []);

  const customerPartyCode = booking.customerInfo?.customer?.partyCode ?? '';

  const hasEditPermission = permissions?.[customerPartyCode]?.hasEditOrder;
  // const hasCreateBookingPermission = permissions?.[customerPartyCode]?.hasCreateBooking;
  // const hasCancelPermission = permissions?.[customerPartyCode]?.hasCancelOrder;

  // const reorderOnClick = () => {
  //   window.localStorage.setItem('selectedAction', 'action-reorder');
  //   analytics.trackEvent('reorder', 'booking reorder', 'button');
  //   window.location.assign(`${config.bookingEditUri}/#/create/${booking.customerOrderNumber}`);
  // };

  const editOnClick = () => {
    window.localStorage.setItem('selectedAction', 'action-edit');
    analytics.trackEvent('editbooking', 'booking update', 'button');
    window.location.assign(`${config.bookingEditUri}/${booking.customerBookingNumber}`)
  };

  // const cancelOnClick = () => {
  // analytics.trackEvent('cancelorder', 'booking cancel', 'button');
  //   handleCancellation();
  // };

  const hasShipment = booking.isLinkedToGfsShipment;
  const isCancelled = booking.conditionRdn === BookingConditions.CANCELLED;

  const hasEdit = () => editAllowed && hasEditPermission;

  // const hasReorder = () => {
  //   const customerCode = order.customerInfo?.customer?.partyCode;
  //   return !!customerCode && hasCreateOrderPermission && !isMultiStopOrder;
  // }

  // const hasCancel = () => {
  //   const customerCode = order.customerInfo?.customer?.partyCode;
  //   const hasCancelRights = customerCode && hasCancelPermission;
  //   return cancelAllowed && hasCancelRights;
  // }

  const actionBtns = [
    // { key: 'action-reorder', displayed: !!hasReorder(), label: translate('Reorder'), startIcon: 'repeat', action: rebookOnClick, disabled: false },
    { key: 'action-edit', displayed: hasEdit(), label: translate('Edit'), startIcon: 'edit', action: editOnClick, disabled: hasShipment || isCancelled},
    // { key: 'action-cancel', displayed: !!hasCancel(), label: translate('Cancel'), startIcon: 'delete', action: cancelOnClick, disabled: isCancelled || hasShipment }
  ].filter(f => f.displayed);

  // const cancelButton = actionBtns.find(f => f.key === 'action-cancel');

  return (
    <Stack
      direction={'row'}
      alignItems='center'
      justifyContent={'center'}
      flexWrap={'wrap'}
      spacing={'8px'}
    >
      {/* TODO */}
      {/* {!useSplitButton && actionBtns.find(f => f.key === 'action-reorder')?.displayed &&
        <Button
          id="reorder-button"
          buttonText={translate('Reorder')}
          onClick={reorderOnClick}
          startIcon='repeat'
          variant='text'
        />
      } */}
      {actionBtns.find(f => f.key === 'action-edit')?.displayed &&
        <Button
          id="edit-order-button"
          buttonText={translate('Edit')}
          onClick={editOnClick}
          disabled={hasShipment || isCancelled}
          startIcon='edit'
          variant="tertiary"
        />
      }
      { /* TODO */}
      {/* {!useSplitButton && actionBtns.find(f => f.key === 'action-cancel')?.displayed &&
        <Button
          id="cancel-order-button"
          buttonText={translate('Cancel')}
          onClick={cancelOnClick}
          disabled={isCancelled || isConsolidated || isMultiStopOrder || isOrderStatusBookedAndHigher}
          startIcon='cancel'
          variant='text'
        />
      } */}
    </Stack>
  );
}
